<template>
  <!-- Content Wrapper. Contains page content -->
  <div>
    <div id="content-wrap" class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <!-- <h1>
          Dashboard
          <small>Version 2.0</small>
        </h1>
        <ol class="breadcrumb">
          <li><a><i class="fa fa-dashboard"></i> Home</a></li>
          <li class="active">Dashboard</li>
        </ol>-->
      </section>

      <section class="content">
        <transition name="page" mode="out-in">
          <router-view></router-view>
        </transition>
      </section>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
    <footer class="main-footer">
      <div class="pull-right hidden-xs"><b>Version</b> {{ app_version }}</div>
      <strong>{{ $t("common.copyright", { "0": this.copy_right }) }}</strong>
    </footer>
    <div>
      <!-- Modal Project List -->
      <div class="modal fade" :ref="`modal-project-list`">
        <div class="modal-dialog modal-lg">
          <project-list
            :items="projectItems"
            @project-select="onSelectProject"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../store";
import ProjectList from "./ProjectList";
import { mapGetters, mapActions } from "vuex";
import config from "../../../build/config"
import siteImgConfig from '@/lib/siteImgConfig'
import utils from '@/lib/utils';

export default {
  name: "lte-content-wrap",
  data() {
    return {
      copy_right: "Avatar Solutions",
      app_title: "Conasi Living",
      app_version: "0.1.757",
      projectItems: [],
      siteImgConfig: siteImgConfig,
    };
  },
  components: {
    "project-list": ProjectList
  },
  watch: {
    PROJECT_LIST: function() {
      let projectItems = [];
      this.PROJECT_LIST.projects.forEach(project => {
        let item = {
          id: project.id,
          selected: project.id == utils.getProjectSession() ? true : false,
          project_name: project.project_name,
          project_code: project.project_code
        };
        projectItems.push(item);
      });
      this.projectItems = projectItems;
    }
  },
  computed: {
    ...mapGetters([
      "PROJECT_LIST"
    ])
  },
  methods: {
    ...mapActions([
      "SET_USER_DATA",
      "GET_AVAILABLE_MODULE",
      "GET_PROJECT_DETAIL",
      "GET_PROJECT_LIST"
    ]),
    viewProjectList: function() {
      this.onToggleProjectList();
    },
    onSelectProject: function(data) {
      let project_id = data.project_id;
      this.GET_AVAILABLE_MODULE({ id: project_id }); // For updating sidebar items
      this.GET_PROJECT_DETAIL({ id: project_id }).then(
        function(res) {
          let projData = res.data
          // sessionStorage.setItem('projectId', project_id) // This was set in ProjectList
          sessionStorage.setItem('projectLogo', projData.project_logo)
          sessionStorage.setItem('projectName', projData.project_name)
          sessionStorage.setItem('projectCode', projData.project_code)
          sessionStorage.setItem('projectDateViewOptions', projData.date_view_options)
          sessionStorage.setItem('projectMonthlyDueDate', projData.monthly_due_date)
          sessionStorage.setItem('invoiceTemplate', projData.invoice_template)
          sessionStorage.setItem('projectMonthlyCalculatePeriodStart', projData.monthly_calculate_period_start)
          sessionStorage.setItem('projectMonthlyCalculatePeriodEnd', projData.monthly_calculate_period_end)
          sessionStorage.setItem('projectMonthlyDataInputPeriodStart', projData.monthly_data_input_period_start)
          sessionStorage.setItem('projectMonthlyDataInputPeriodEnd', projData.monthly_data_input_period_end)

          this.setDefaultTitle(`${this.app_title} - ${projData.project_name}`);
          this.onToggleProjectList("hide");
          store.commit("SET_ACTIVATED_PROJECT", project_id);
          this.SET_USER_DATA().then(
            function() {
              // this.$router.push({ path: "/dashboard" })
            }.bind(this)
          )
          .catch(
            function(error) {
              //session timeout -> redirect to login
              this.signOut();
            }.bind(this)
          );
        }.bind(this)
      );
      if (data.is_selected === true) {
        const pathName = sessionStorage.getItem("pathPosition");
        this.$router.push({ path: "/dashboard" });
        if (pathName === "/dashboard") {
          setTimeout(function() {
            location.href = "/";
          }, 1000);
        }
      }
    },
    onToggleProjectList: function(action = "show") {
      $(this.$refs[`modal-project-list`]).modal(action);
    },
    setDefaultTitle: function(projectTitle) {
      document.title = projectTitle;
    },
    getSiteInfo: function() {
      let results = null
      let index = this.siteImgConfig.findIndex(x=>x.site_name_info_value===config.SITE_NAME_INFO)
      if (index !== -1) {
        results = this.siteImgConfig[index]
      }
      return results
    },
    updateTabTitle: function() {
      var link = document.querySelector("link[rel*='shortcut icon']");
      let siteInfo = this.getSiteInfo()
      link.href = siteInfo.urlIcon
      this.app_title = siteInfo.site_name_info
      this.copy_right = siteInfo.name
    }
  },
  mounted() {
    this.updateTabTitle()
    // const current_host = document.location.hostname;
    // if (current_host.indexOf("conasi.vn") === -1) {
    //   var link = document.querySelector("link[rel*='shortcut icon']");
    //   if (link) {
    //     link.type = "image/png";
    //     link.rel = "shortcut icon";
    //     if (current_host.indexOf("avatarnext.com") !== -1) {
    //       if (current_host.indexOf("apartment") !== -1) {
    //         this.copy_right = "Avatar Solutions";
    //         this.app_title = "a' Apartment";
    //         link.href = "/static/images/avatar_logo.png";
    //       } else {
    //         // if (current_host.indexOf('test') !== -1) {
    //         link.href = "/static/images/lumiere_logo.png";
    //       }
    //     } else {
    //       link.href = "/static/images/local_logo.png";
    //       this.copy_right = "Avatar Solutions";
    //     }
    //   }
    // }
    this.GET_PROJECT_LIST().then(
      function() {
        let projectId = utils.getProjectSession();
        if (!projectId) {
          this.$router.push({ path: "/no-project" });
          this.onToggleProjectList()
        } else {
          let data = {
            project_id: projectId,
            is_selected: false //refresh
          };
          this.onSelectProject(data);
        }
      }.bind(this)
    );
  }
};
</script>

<style scoped>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.page-enter,
.page-leave-to {
  opacity: 0;
}
.btn-label {
  position: relative;
  left: -12px;
  display: inline-block;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px 0 0 3px;
}
.btn-labeled {
  padding-top: 0;
  padding-bottom: 0;
}
.btn {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/ContentWrap.vue